export default __webpack_public_path__ + "static/media/fitness.c60d9cc5.jpg";